"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18n = require("@insolus/react-i18n");

var _isStringArray = function _isStringArray(node) {
  return Array.isArray(node) && node.every(function (item) {
    return typeof item === 'string';
  });
};

var Empty = function Empty(props) {
  var _useTranslate = (0, _reactI18n.useTranslate)('ui-kit'),
      __ = _useTranslate.__;

  var children = props.children,
      className = props.className;

  var description = props.description || __('empty.text');

  if (_isStringArray(description)) {
    description = description.join('\n');
  }

  return React.createElement("div", {
    className: (0, _classnames.default)(className, 'Empty')
  }, description && React.createElement("p", {
    className: "Empty__description"
  }, description), children && React.createElement("div", {
    className: "Empty__content"
  }, children));
};

Empty.defaultProps = {
  description: undefined,
  className: undefined,
  children: undefined
};
var _default = Empty;
exports.default = _default;